module.exports = __webpack_public_path__ + "static/media/404error.404109fa.svg";